import React, { useCallback, useEffect, useState } from 'react';

import Button from '../../../components/Button';
import { useToast } from '../../../hooks/toast';

import api from '../../../services/api';
import getResponseErrors from '../../../utils/getResponseErrors';
import Loading from '../../../components/Loading';

import { IFilaChamado } from '../../AgendaAtendimento';
import { ISendMessage } from '../../../components/Chat';
import socket from '../../../services/socket';
import { Lista } from './styles';

interface IFilaFormatada extends IFilaChamado {
  audio?: string;
}
const PacientesChamados: React.FC = () => {
  const { addToast } = useToast();

  const [loading, setLoading] = useState(false);

  const [fila, setFila] = useState<IFilaChamado[]>([]);

  useEffect(() => {
    async function loadDados(): Promise<void> {
      setLoading(true);
      try {
        const response = await api.get<IFilaFormatada[]>('/filaChamados');

        const filaFormatada = response.data.map(fl => ({
          ...fl,
          Arquivo: fl.audio,
        }));
        console.log(filaFormatada);
        setFila(filaFormatada);
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Não foi possível buscar fila de pessoas',
          type: 'error',
          description: mensagemErro,
        });
      } finally {
        setLoading(false);
      }
    }
    loadDados();
  }, []);

  useEffect(() => {
    const handleNewMessage = (data: ISendMessage): void => {
      const chamado: IFilaFormatada = {
        AgeCodigo: data.idFrom,
        Arquivo: data.audioUrl,
        audio: data.audioUrl,
        PacCodigo: data.idTo,
        Texto: data.mensagem,
        Sala: data.from,
        PacNome: data.to,
      };

      setFila(state => {
        const estado = state.find(
          st =>
            st.PacCodigo === chamado.PacCodigo &&
            st.AgeCodigo === chamado.AgeCodigo,
        );

        if (estado) return state;

        return state ? [chamado].concat(state) : [chamado];
      });
    };

    socket.on('chamar_paciente_painel', handleNewMessage);
    return () => {
      socket.removeEventListener('chamar_paciente_painel', handleNewMessage);
    };
  }, []);

  const handleChamarPaciente = useCallback((dados: IFilaChamado) => {
    const mensagem: ISendMessage = {
      clinica: '1',
      from: dados.Sala,
      idFrom: dados.AgeCodigo,
      to: dados.PacNome,
      idTo: dados.PacCodigo,
      mensagem: dados.Texto,
      lida: false,
      created_at: new Date(),
      painel: true,
      audioUrl: dados.Arquivo,
    };
    socket.emit('chamar_paciente', mensagem);
  }, []);

  return (
    <>
      {loading && <Loading backgroundBlack={false} />}

      {fila.length === 0 && <h2>Sem pacientes chamados.</h2>}

      {fila.length > 0 && (
        <Lista>
          <table style={{ fontSize: '0.9rem' }}>
            <thead>
              <tr>
                <th>Paciente</th>
                <th>Sala</th>
                <th> - </th>
              </tr>
            </thead>
            <tbody>
              {fila.map(f => (
                <tr key={`td-${f.PacCodigo}-${f.AgeCodigo}-${f.Sala}`}>
                  <td>{f.PacNome}</td>
                  <td>{f.Sala}</td>
                  <td>
                    <Button
                      type="button"
                      variant="primary-outline"
                      className={`py-0 `}
                      style={{ height: '23px' }}
                      onClick={() => handleChamarPaciente(f)}
                    >
                      Chamar novamente
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Lista>
      )}
    </>
  );
};

export default PacientesChamados;
